import constants, { ACCESS_TOKEN, default_size, HTTP_METHODS } from "../../../settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getClusterList(page = 0, size = default_size) {
    return axiosClient({
        url: `${constants.api.cluster.getk8s}?page=${page}&size=${size}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}   

function createCluster(data) {
    return axiosClient({
        url: constants.api.cluster.create_cluster,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function deleteCluster(id) {
    return axiosClient({
        url: constants.api.cluster.delete_cluster + id ,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ''
    })
}

function forceDeleteCluster(id) {
    return axiosClient({
        url: constants.api.cluster.forcedelete_cluster + id,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ''
    })
}

function clusterStatus(id) {
    return axiosClient({
        url: constants.api.cluster.cluster_status + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}
function stopCluster(id) {
    return axiosClient({
        url: constants.api.cluster.stopcluster + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function restartCluster(id) {
    return axiosClient({
        url: constants.api.cluster.restartcluster + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function startCluster(id) {
    return axiosClient({
        url: constants.api.cluster.startcluster + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function saveClusterConfig(data) {
    return axiosClient({
        url: constants.api.cluster.save_cluster_config,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data
    })
}

function getClusterConfig(clusterId) {
    return axiosClient({
        url: `${constants.api.cluster.get_cluster_config}/${clusterId}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function listPods(clusterId, page = 0, size = 20) {
    const params = new URLSearchParams();
    if (clusterId) params.set("clusterId", clusterId);
    params.set("page", String(page));
    params.set("size", String(size));
    return axiosClient({
        url: `${constants.api.cluster.list_pods}?${params.toString()}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function getPodLiveStatus(podId) {
    return axiosClient({
        url: `${constants.api.cluster.pod_live}${podId}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

/** Fetch pod/workload by source id (project id in Agent Workflow). */
function getPod(srcId) {
    return axiosClient({
        url: `${constants.api.cluster.get_pod}${srcId}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function deletePod(podId) {
    return axiosClient({
        url: `${constants.api.cluster.delete_pod}${podId}`,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ''
    })
}

//To export run function
const ClusterService = {
    getClusterList,
    createCluster,
    deleteCluster,
    forceDeleteCluster,
    clusterStatus,
    stopCluster,
    restartCluster,
    startCluster,
    saveClusterConfig,
    getClusterConfig,
    listPods,
    getPodLiveStatus,
    getPod,
    deletePod
}
export default ClusterService;
